export function validate(test, errors) {
    if (typeof test === 'function') {
        test = test();
    }
    return test ? null : errors;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvdXRpbHMvdmFsaWRhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsTUFBTSxVQUFVLFFBQVEsQ0FBQyxJQUErQixFQUFFLE1BQXFCO0lBQzdFLElBQUksT0FBTyxJQUFJLEtBQUssVUFBVSxFQUFFO1FBQzlCLElBQUksR0FBRyxJQUFJLEVBQUUsQ0FBQTtLQUNkO0lBRUQsT0FBTyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFBO0FBQzdCLENBQUMifQ==